import { render } from "./UIMenuItem.vue?vue&type=template&id=cffd4c90"
import script from "./UIMenuItem.vue?vue&type=script&lang=js"
export * from "./UIMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe-registry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__